import { Module } from 'vuex'

import { ContributerState, RootState } from '@/types/store'

import { getters } from './getters'
import { actions } from './actions'
import { mutations } from './mutations'

const state: ContributerState = {
  contributers: [],
  total: -1,
  isContributersLoading: false,
}

export const contributer: Module<ContributerState, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
